module.exports = __webpack_public_path__ + "static/img/雅生ShowerSelectID特殊材质面板AXORSignaturePlates.9c11ab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/雅生ShowerSelectID特殊材质面板AXORSignaturePlates.jpg
// module id = w0u/
// module chunks = 1